export const surveySlice = (set, get) => ({

  survey: {
    id: "",
    title: "Survey Title1",
    description: "Description for the survey.",
    pageOption: "all",
    completeMessage: "Thank you for filling the survey.",
    redirectUrl: "",
    titlePosition: "left",
    logoPosition: "left",
    hasLogo: false,
    logoUrl: "",
    data: [],
  },

  setId: (id) =>
    set((state) => ({
      survey: {
        ...state.survey,
        id: id,
      },
    })),

  setPageOption: (pageOption) =>
    set((state) => ({
      survey: {
        ...state.survey,
        pageOption: pageOption,
      },
    })),

  setCompleteMessage: (completeMessage) =>
    set((state) => ({
      survey: {
        ...state.survey,
        completeMessage: completeMessage,
      },
    })),

  setRedirectUrl: (redirectUrl) =>
    set((state) => ({
      ...state.survey,
      redirectUrl: redirectUrl,
    })),

  setTitlePostion: (titlePosition) =>
    set((state) => ({
      survey: {
        ...state.survey,
        titlePostion: titlePosition,
      },
    })),

  setLogoPostion: (logoPosition) =>
    set((state) => ({
      survey: {
        ...state.survey,
        logoPosition: logoPosition,
      },
    })),

  setLogoUrl: (logoUrl) =>
    set((state) => ({
      survey: {
        ...state.survey,
        logoUrl: logoUrl,
      },
    })),

  addDataItem: (payload) =>
    set((state) => ({
      survey: {
        ...state.survey,
        data: [...state.survey.data, payload],
      },
    })),

  updateDataItem: (index, payload) =>
    set((state) => ({
      survey: {
        ...state.survey,
        data: state.survey.data.map((item, i) => (i === index ? item : payload)),
      },
    })),

  moveDataItem: (hoverIndex, dragIndex) =>
    set((state) => {
      const newData = [...state.survey.data];
      const [dragItem] = newData.splice(dragIndex, 1);
      newData.splice(hoverIndex, 0, dragItem);
      return {
        survey: {
          ...state.survey,
          data: newData,
        },
      };
    }),

  setTitle: (title) =>
    set((state) => {
      console.log("Set Title:"+title)
      console.log(state.survey)
      return({
      survey: {
        ...state.survey,
        title: title,
      },
    })}),

  setDescription: (description) =>
    set((state) => ({
      survey: {
        ...state.survey,
        description: description,
      },
    })),

  deleteSelectedQuestion: (index) =>
    set((state) => ({
      survey: {
        ...state.survey,
        data: state.survey.data.filter((_, i) => i !== index),
      },
    })),
  addChoiceToDataItem: (index, choice) =>
    set((state) => ({
      survey: {
        ...state.survey,
        data: state.survey.data.map((item, i) =>
          i === index && item.hasOwnProperty("choice")
            ? { ...item, choice: [...item.choice, choice] }
            : item
        ),
      },
    })),
 
  updateChoiceInDataItem: (index, choiceIndex, updatedChoice) =>
    set((state) => ({
      survey: {
        ...state.survey,
        data: state.survey.data.map((item, i) =>
          i === index && item.hasOwnProperty("choice")
            ? {
                ...item,
                choice: item.choice.map((c, j) =>
                  j === choiceIndex ? updatedChoice : c
                ),
              }
            : item
        ),
      },
    })),

  deleteChoiceFromDataItem: (index, choiceIndex) =>
    set((state) => ({
      survey: {
        ...state.survey,
        data: state.survey.data.map((item, i) =>
          i === index && item.hasOwnProperty("choice")
            ? {
                ...item,
                choice: item.choice.filter((_, j) => j !== choiceIndex),
              }
            : item
        ),
      },
    })),

  toggleHasLogo: () =>
    set((state) => ({
      survey: {
        ...state.survey,
        hasLogo: !state.survey.hasLogo,
      },
    })),
  setSurvey: (surveydata) => {
    set((state) => ({
      survey: {
        id: surveydata.id,
        title: surveydata.title,
        description: surveydata.description,
        pageOption: surveydata.pageOption,
        completeMessage: surveydata.completeMessage,
        redirectUrl: surveydata.redirectUrl,
        titlePosition: surveydata.titlePosition,
        logoPosition: surveydata.logoPosition,
        hasLogo: surveydata.hasLogo,
        logoUrl: surveydata.logoUrl,
        data: surveydata.data,
      },
    }));
  },

  resetSurvey:()=>{
    set((state)=>({
     survey:{ id: "",
      title: "Survey Title",
      description: "Description for the survey.",
      pageOption: "all",
      completeMessage: "Thank you for filling the survey.",
      redirectUrl: "",
      titlePosition: "left",
      logoPosition: "left",
      hasLogo: false,
      logoUrl: "",
      data: [],
    },
    }))
  }
});
